import { render, staticRenderFns } from "./ModalDescuentos.vue?vue&type=template&id=17eeafd3"
import script from "./ModalDescuentos.vue?vue&type=script&lang=js"
export * from "./ModalDescuentos.vue?vue&type=script&lang=js"
import style0 from "./ModalDescuentos.vue?vue&type=style&index=0&id=17eeafd3&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports